import { useMemo } from 'react';
import type { PageType } from '../../types/PhotoCardType';
import type { InfiniteData } from 'react-query';

interface UseFilterPhotoCardsProps {
  data: InfiniteData<PageType> | null;
  hasMyPhotoCards: boolean;
  isMyPhotoCardsOnly: boolean;
}

export default function useFilterPhotoCards({
  data,
  hasMyPhotoCards,
  isMyPhotoCardsOnly
}: UseFilterPhotoCardsProps) {
  const processedEvents = useMemo(() => {
    if (!data?.pages) return [];

    if (!hasMyPhotoCards) {
      //오버레이 뷰를 위한 포토카드 데이터처리 : 3개 이벤트, 색상처리를 위해 collectedCount를 1로 설정
      const OVERLAY_TRUNCATE_COUNT = 3;
      // 첫 페이지에 빈 이벤트가 섞여 있을 수 있으므로, 로드된 모든 페이지에서
      // 포토카드가 존재하는 이벤트만 추려 상위 N개만 사용한다.
      const allLoadedEvents = data.pages.flatMap((page) => page.events || []);
      const candidateEvents = allLoadedEvents.filter(
        (event) => event?.photoCards && event.photoCards.length > 0
      );
      const overlayViewEvents = candidateEvents.slice(0, OVERLAY_TRUNCATE_COUNT);

      return overlayViewEvents.map((event) => {
        const photoCards = event.photoCards.map((photoCard) => ({
          ...photoCard,
          collectedCount: 1
        }));
        return { ...event, photoCards };
      });
    }

    //내 포토카드만 보기 필터링
    return data.pages.flatMap((page) =>
      page.events
        .map((event) => ({
          ...event,
          photoCards: event?.photoCards?.filter((photoCard) =>
            isMyPhotoCardsOnly ? photoCard.collectedCount > 0 : true
          )
        }))
        //빈 포토카드 배열을 가진 이벤트 제거
        .filter((event) => event.photoCards && event.photoCards.length > 0)
    );
  }, [data, hasMyPhotoCards, isMyPhotoCardsOnly]);

  return {
    processedEvents
  };
}
